import classNames from 'classnames';
import {injectIntl} from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';

import Box from '../box/box.jsx';
import ReactModal from 'react-modal';
import styles from './extension-modal.css';
import {isMobile} from '../../lib/platform';
import CloseButton from '../close-button/close-button.jsx';

class ExtensionLibraryComponent extends React.Component {
    constructor (props) {
        super(props);

        this.state = {};
    }

    render () {
        return (
            <ReactModal
                isOpen
                className={classNames(
                    styles.modalContent,
                    styles.extensionBox,
                    this.props.className,
                    {[styles.mobile]: isMobile()}
                )}
                contentLabel={this.props.contentLabel}
                id={this.props.id}
                overlayClassName={classNames(styles.modalOverlay, {
                    [this.props.overlayClassName]: this.props.overlayClassName
                })}
                onRequestClose={this.props.onRequestClose}
            >
                <div className={classNames(styles.header)}>
                    <div
                        className={classNames(
                            styles.headerItem,
                            styles.headerItemTitle
                        )}
                    >
                        选择拓展
                    </div>
                    <div
                        className={classNames(
                            styles.headerItem,
                            styles.headerItemClose
                        )}
                    >
                        <CloseButton
                            size={CloseButton.SIZE_LARGE}
                            onClick={this.props.onRequestClose}
                        />
                    </div>
                </div>

                <Box className={styles.editorWrapper}>
                    {this.props.children}
                </Box>
            </ReactModal>
        );
    }
}

ExtensionLibraryComponent.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    contentLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
        .isRequired,
    id: PropTypes.string.isRequired,
    onRequestClose: PropTypes.func,
    overlayClassName: PropTypes.string
};

export default injectIntl(ExtensionLibraryComponent);
